import { setupFormState } from '@/components/form/tidal-form'

import { TestEmailNotificationFormValues } from './types'

export const form = setupFormState<TestEmailNotificationFormValues>({
  id: 'TestEmailNotificationForm',
  initialValues: {
    id: '',
    email: '',
  },
})
